import styled from "styled-components";

export const Wrapper = styled.div`
  display: flex;
  position: absolute;
  align-items: center;
  height: 80%;
`;
